



































import { Component, Vue, Watch } from "vue-property-decorator";
import { deleteElement } from "@/api/delite/delite-element";
import { IReason } from "@/@types/orders/reason";
import { order } from "@/config/host.config";

import OrderReasonForm from "@/components/forms/orders/order-reason-form.vue";
import ReasonList from "@/components/tables/orders/reason/reason-list.vue";
import InputSearch from "@/components/app/search/input-search.vue";
import ButtonBack from "@/components/buttons/button-back.vue";
import ButtonCart from "@/components/buttons/button-cart.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: {
    StandartModal,
    OrderReasonForm,
    InputSearch,
    ButtonBack,
    ButtonCart,
    ReasonList,
  },
})
export default class OrderReasonModal extends Vue {
  reasonList: Array<IReason> = [];
  deleted = false;
  reason_id = "";
  search = "";

  get reasons(): Array<IReason> {
    return this.reasonList.filter((reason) => {
      if (reason.name)
        return (
          this.$getLocale(reason.name)
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) > -1
        );
    });
  }

  get reason(): IReason | null {
    const reason = this.reasonList.find((r) => r._id == this.reason_id);
    return reason ? reason : null;
  }

  async sendReason(data: Partial<IReason>): Promise<void> {
    const method = this.reason_id ? "put" : "post";
    const uri = this.reason
      ? order.reason + "/" + this.reason_id
      : order.reason;
    try {
      const res = await this.$axios[method](uri, data);
      if (res.status === 200) {
        this.$bvModal.hide("add-reasom-modal");
        if (!this.reason_id) {
          this.reasonList.push(res.data);
          return;
        }

        const i = this.reasonList.findIndex((r) => r._id == this.reason_id);
        if (i < 0) {
          this.createReasonList();
          return;
        }
        this.$set(this.reasonList, i, res.data);
      }
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.200")),
      });
    } catch (e) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  async clearReason(id: string): Promise<void> {
    const i = this.reasonList.findIndex((reason) => reason._id == id);
    if (i < 0) return this.createReasonList();
    this.reasonList.splice(i, 1);
  }

  async restoreReason(id: string): Promise<void> {
    const uri = order.reason_restore + "/" + id;
    try {
      const res = await this.$axios.put(uri);
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.clearReason(id);
      }
    } catch (e) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  deleteReason(id: string): void {
    const uri = this.deleted ? order.reason_forse : order.reason;
    deleteElement(id, uri)
      .then(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.clearReason(id);
      })
      .catch(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
      });
  }

  mustChangeReason(id: string): void {
    this.reason_id = id;
    this.$nextTick(() => this.$bvModal.show("add-reasom-modal"));
  }

  @Watch("deleted")
  async createReasonList(): Promise<void> {
    this.reasonList = [];
    const params = { "match[deleted][value]": this.deleted };
    try {
      const res = await this.$axios.get(order.reason, { params });
      if (res.status === 200) this.reasonList = res.data;
    } catch (error) {
      console.log(error);
    }
  }

  mounted(): void {
    this.createReasonList();
  }
}
